import { createAction, props } from '@ngrx/store';
import { IOutputCheck } from 'src/app/spa/models/spa-project.model';
import { IDashboardProject, IDashboardProjectsFilter } from '../models/dashboard.model';

export const GetProjects = createAction('[Dashboard] Get projects');

export const GetProjectsSuccess = createAction(
  '[Dashboard] Get projects success',
  props<{ projects: IDashboardProject[] }>()
);

export const GetProjectsFailed = createAction('[Dashboard] Get projects failed', props<{ payload: Error }>());

export const ClearProjects = createAction('[Dashboard] Clear projects');

export const GetChecks = createAction('[Dashboard] Get checks');

export const GetChecksSuccess = createAction('[Dashboard] Get checks success', props<{ checks: IOutputCheck[] }>());

export const GetChecksFailed = createAction('[Dashboard] Get checks failed', props<{ payload: Error }>());

export const ApplyFilters = createAction('[Dashboard] Apply filters', props<{ filters: IDashboardProjectsFilter }>());
